<template>
  <b-row class="item-details-container ">
     <b-col >
        <b-list-group-item>
          <a  :href="'#item-details-'+category.id" draggable="false" class='wrapper-a' @click="clickToExpanding" >
            <b-row>
              <b-col class="px-0" cols="2" sm="1">
                <div class="toggle-icon"  @click.prevent>
                  <span v-if="isVisible" aria-hidden="true"><b-icon variant="secondary" icon="caret-right-fill" font-scale="2.2" v-b-popover.hover.left="'View Items'"></b-icon></span>
                  <span v-else aria-hidden="true"><b-icon variant="secondary" icon="caret-down-fill" font-scale="2.2" v-b-popover.hover.left="'View Items'"></b-icon></span>
                </div>
              </b-col>
              <b-col class="pl-0" cols="7" sm="9">
                  <b-form-input v-model="updCat.name"  @change="updateCategory()"></b-form-input>
              </b-col>
              <b-col cols="1" class="pl-0 ml-0 my-auto" >
                <b-form-checkbox v-model="activeCategory" switch @input="updateCategory()">
                  <span v-if="updCat.active==true">Active</span>
                  <span v-else>Inactive</span>
                </b-form-checkbox>
              </b-col>
            </b-row>
          </a>

          <b-collapse class="category-card" :id="'item-details-'+category.id" v-model="isVisible">
            <b-row class="py-2">
              <b-col style="text-align:center;">
                <b-button variant="outline-danger" @click="confirmCategoryDelete">Delete?</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <h5 style="text-align:center;" class="pt-2">Items</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-list-group>
                  <draggable  v-model="catitems" @end="dragend" :options="{ forceFallback: true }">
                    <CategoryItems
                      v-for="catitem of catitems"
                      v-bind:catitem="catitem"
                      v-bind:key="catitem.id"
                      :category_id="category.id"
                      :totalcatitems="totalcatitems"
                      @emit-refresh-items="retrieveCategoryItems"
                      @emit-switch-overlay="emitSwitchOverlay">
                    </CategoryItems>
                  </draggable>
                  <!-- Datalist searching for items to add to category -->
                  <b-list-group-item>
                    <b-form-input v-model="catname" :list="'item-list'+category.id" placeholder="Search for item" @update="fetchSearchItems()" @change="addCategoryItem()"></b-form-input>
                    <datalist :id="'item-list'+category.id">
                      <option v-for="item in items" :key="item.id">{{ item.name }}</option>
                    </datalist>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
          </b-collapse>
        </b-list-group-item>
     </b-col>
    <div class="draggable-btn handle" >
       <p class="h4 mb-2"> <b-icon icon="grid3x2-gap-fill" variant="secondary" ></b-icon></p>
    </div>
  </b-row>
</template>
<script>
import CategoryItems from '@/components/CategoryItems.vue'
import draggable from 'vuedraggable';
export default {
  name: 'CategoryList',
  components: {
    CategoryItems,
    draggable
  },
  props: ['category'],
  data () {
    return {
      updCat: {
        name: this.category.name,
        active: this.category.active
      },
      confirmDel: '',
      catitems: [],
      totalcatitems: '',
      items: [],
      catname: '',
      isVisible : false ,
    }
  },

  computed: {
    activeCategory: {
      get: function() {
        return this.category.active;
      },
      set: function(newVal) {
        this.updCat.active = newVal;
      }
    },

    namefilter: function() {
      if (this.catname != '') {
        return '&name='+this.catname;
      } else {
        return '';
      }
    },

  },

  methods: {
    clickToExpanding(event){
      const currentIsVisible = this.isVisible ;
      const clickedTag = event.target.tagName ;
      const classTarget = event.target.classList[0];
      if(clickedTag.includes('SPAN') || clickedTag.includes('LABEL') || (clickedTag.includes('INPUT') && event.target.type === 'checkbox' ))
      {
        return ;
      }
      else if(clickedTag.includes('INPUT')|| clickedTag.includes('BUTTON')
              || ( clickedTag.includes('svg') && (classTarget === "bi-x-circle") )
              || (classTarget ==="list-group-item"))
      {
         event.preventDefault();
         event.stopPropagation();
        this.isVisible = currentIsVisible ;
      }
      else{
        event.preventDefault();
        this.isVisible = !currentIsVisible;
      }

    },
    dragend() {
      var catitems = [];
      var i=1;
      for (const catitem of this.catitems) {
        catitems.push({
          "item_id": catitem.id,
          "sort_order": i
        });
        i+=1;
      }
      catitems = {"items_sort": catitems}
      this.updateCatItemSort(catitems);
    },

    emitFetchCategories() {
      this.$emit('emit-fetch-categories');
    },

    emitSwitchOverlay(bool) {
      this.$emit('emit-switch-overlay', bool);
    },

    async retrieveCategoryItems() {
      // Check to see if there items associated with this Category?
      const { data } = await this.$api.get('categories/'+this.category.id+'/items?limit=50&active=True');
      if (data.success == true) {
        this.catitems = data.items;
        this.totalcatitems = data.total_items;
        this.emitSwitchOverlay(false);
      }
    },

    async confirmCategoryDelete() {
        // Check to see if there items associated with this Category?
        const { data } = await this.$api.get('categories/'+this.category.id+'/items');
        if (data.success == true) {
          if (data.total_items > 0) {
            // If yes, give them this message
            this.$bvModal.msgBoxOk('There are Items associated with this Category. Please remove them before deleting, or consider setting Category to Inactive.', {
              title: 'Unable to Delete',
              centered: true
            })
          } else {
            // if not, get a confirmation before deleting
            this.confirmDel = ''
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete category '+this.category.name+'!', {
              title: 'Please confirm delete',
              centered: true
            })
            // Confirmed - you can delete the category now!
            .then(value => {
              this.confirmDel = value
              if (this.confirmDel == true) {
                this.deleteCategory();
              }
            })
            // Error processing modal
            .catch(err => {
              console.log('an error has occurred. '+ err)
            })
          }
        } else {
          // Error retrieving category-items
          this.$bvModal.msgBoxOk('There was a problem with this process, please try again later.', {
            title: 'Unspecified error',
            centered: true
          })
        }
    },

    async deleteCategory() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // update order with status of 'ready'
      const { data } = await this.$api.delete('categories/'+this.category.id,
        config
      );
      if (data.deleted == true) {
        this.emitFetchCategories();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem deleting the category, please try again later.', {
          title: 'Error deleting category',
          centered: true
        })
      }
    },

    async updateCategory() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "name": this.updCat.name,
        "active": this.updCat.active
      }
      // update order with status of 'ready'
      const { data } = await this.$api.patch('categories/'+this.category.id,
        body,
        config
      );
      if (data.success == true) {
        this.emitFetchCategories();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the category, please try again later.', {
          title: 'Error updating category',
          centered: true
        })
      }
    },

    async fetchSearchItems() {
      // this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("items?active=True&exccat="+this.category.id+this.namefilter, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.items = await data.items;
      // this.emitSwitchOverlay(false);
    },

    async addCategoryItem() {
      const res = this.items.filter(i => i.name == this.catname);
      var item_id = res[0].id;
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "item_id": item_id
      }
      // update order with status of 'ready'
      const { data } = await this.$api.post('categories/'+this.category.id+'/items',
        body,
        config
      );
      if (data.created == true) {
        this.emitSwitchOverlay(false);
        this.retrieveCategoryItems();
        this.catname = '';
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem adding the item to the category, please try again later.', {
          title: 'Error updating category',
          centered: true
        })
      }
    },

    async updateCatItemSort(catitems) {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = catitems;
      // update order with status of 'ready'
      const { data } = await this.$api.patch('categories/'+this.category.id+'/items/sortorder',
        body,
        config
      );
      if (data.success == true) {
        this.emitSwitchOverlay(false);
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem updating the sort order, please try again later.', {
          title: 'Error updating sort order',
          centered: true
        })
      }
    },

  },

  created: function() {
    this.retrieveCategoryItems();
  }
}
</script>

<style scoped>
 .toggle-icon{
   margin : 6px 5px;
 }
  .wrapper-a{
    text-decoration: none;
    color: initial;
  }
  .wrapper-a:hover{
    text-decoration: none;
    color: initial;
  }
  .list-group-item{
    position: relative;
    border: 0.2px solid rgb(238, 238, 238) ;
    margin: 10px 0px;
    border-radius: 6px;
    box-shadow: 0 1px 0px rgb(84 70 35 / 15%), 0 0px 2px 0px rgb(84 70 35 / 15%);
  }
  .list-group-item:hover{
    box-shadow: 0 2px 6px rgb(84 70 35 / 15%), 0 1px 3px rgb(84 70 35 / 15%);
  }

  .item-details-container > .col{
    padding: 0px;
  }
  .draggable-btn{
    position: relative;
    margin: auto 0px;
    cursor: pointer;
  }
  .draggable-btn > * {
    transform: rotateZ(270deg);
  }
  .form-control{
    outline: none;
    border-inline: none;
    border: none;
  }
  .form-control:focus{
    border-color: gray;
    box-shadow: 0 0 0px 1px rgb(109 109 109 / 25%);
    background-color: transparent;
    outline: 0;
  }
</style>
